import ComparisonTemplate from '../vs/ComparisonTemplate'

const competitor = {
  name: 'Track Your Dividends',
  slug: 'trackyourdividends',
  tagline: 'Track Your Dividends is a popular free dividend tracker. Here\'s a full feature comparison with Safe Dividend Tracker.',
  category: 'Dividend tracker',
  seoTitle: 'Safe Dividend Tracker vs Track Your Dividends — Full Comparison',
  seoDescription: 'Safe Dividend Tracker vs Track Your Dividends: feature comparison and pricing. See why investors switch for covered call tracking, better mobile apps, and DRIP projections.',
  price: 'Free / $3.99/month',
  priceNote: 'Track Your Dividends pricing based on publicly available information and may change.',
  features: {
    free:     true,
    divTrack: true,
    drip:     'partial',
    calendar: true,
    cc:       false,
    csp:      false,
    wheel:    false,
    sync:     true,
    mobile:   'partial',
    reports:  'partial',
    webull:   false,
  },
  strengths: [
    'Long-standing free tier — good starting point for investors new to dividend tracking.',
    'Large ticker database covering thousands of US and international dividend stocks.',
    'Simple, no-fuss interface that\'s easy to pick up without a learning curve.',
    'Active community with user forums and discussion boards.',
  ],
  verdict: {
    sdtWins: [
      'Covered call & wheel strategy tracker',
      'Full DRIP snowball projections',
      'Native iOS & Android apps',
    ],
    bottomLine: 'Track Your Dividends is a solid beginner tool — but it hasn\'t kept pace with modern investors who also trade options. Safe Dividend Tracker gives you everything TYD offers on the free tier, adds full DRIP projections, a covered call and wheel strategy tracker, and better native mobile apps.',
  },
  bestFor: {
    sdt: 'You trade covered calls or cash-secured puts alongside collecting dividends. You want a mobile app that keeps up with your portfolio. You want full DRIP snowball projections built in.',
    competitor: 'You\'re a pure dividend investor who wants the simplest possible interface and has no interest in options income tracking.',
  },
  faq: [
    {
      q: 'Is Track Your Dividends free?',
      a: 'Track Your Dividends has a free tier with limited features and a paid Pro tier. Safe Dividend Tracker also has a free plan with no time limit, and includes more features at the free level including full DRIP projections.',
    },
    {
      q: 'Can Track Your Dividends track covered calls?',
      a: 'No. Track Your Dividends is a dividend-only tracker. It does not track covered calls, cash-secured puts, or the wheel strategy. If you generate options income alongside dividends, Safe Dividend Tracker is the better choice.',
    },
    {
      q: 'Does Track Your Dividends have a mobile app?',
      a: 'Track Your Dividends has a mobile-responsive website but limited native app functionality. Safe Dividend Tracker has dedicated iOS and Android apps available on the App Store and Google Play.',
    },
    {
      q: 'How do I move from Track Your Dividends to Safe Dividend Tracker?',
      a: 'Sign up for free at Safe Dividend Tracker and add your holdings manually or use brokerage sync (Premium). The process takes about 10 minutes for most portfolios.',
    },
  ],
}

export default function VsTrackYourDividends() {
  return <ComparisonTemplate competitor={competitor} />
}
